import { Box } from '@material-ui/core';
import classNames from 'classnames';
import { SGSForm, SGSFormDate } from 'components';
import { ReasonForWorkStop } from 'features/arretTravail/models/workStopReason';
import React from 'react';
import styles from '../../../../css/ArretTravail.module.scss';

type FirstConstationDateSectionProps = {
    store: any;
};

const FirstConstationDate: React.FC<FirstConstationDateSectionProps> = ({ store }) => {
    const hasFirstConstationDate = store.reasonForWorkStopCod === ReasonForWorkStop.MaladieProfessionnelle;

    if (!hasFirstConstationDate) {
        delete store?.workStoppage?.infos?.firstConstatationDate;
        return null;
    }

    return (
        <>
            <Box className={classNames(styles.title, 'mb-4')}>1ère constatation médicale de la maladie professionnelle :</Box>
            <SGSForm.Row>
                <SGSForm.Col md={6}>
                    <SGSFormDate inputVariant="outlined" name="workStoppage.infos.firstConstatationDate" label="workStop.fields.workStoppage.infos.firstConstatationDate" />
                </SGSForm.Col>
            </SGSForm.Row>
        </>
    );
};

export default FirstConstationDate;
